/**
 * STYLING: Plain Tailwind ONLY!
 * Generic pill-button group used in TextToolSettings.
 */

interface Props {
  label: string;
  items: Array<{ id: string; label: string }>;
  selected: string;
  onSelect: (id: string) => void;
  allowDeselect?: boolean;
}

export function PillGroup({ label, items, selected, onSelect, allowDeselect }: Props) {
  const handleClick = (id: string) => {
    if (allowDeselect && selected === id) {
      onSelect('');
    } else {
      onSelect(id);
    }
  };

  return (
    <div>
      <span className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">{label}</span>
      <div className="flex gap-1.5 flex-wrap">
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => handleClick(item.id)}
            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${
              selected === item.id
                ? 'bg-primary-600 text-white'
                : 'bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-200 dark:hover:bg-neutral-700'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
